module.exports = "<privacy-form></privacy-form>";